'use client';

import { useLayoutEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Shown while the society for the current URL is being resolved. Renders a
 * plain centered spinner on a neutral background — critically, it stops the
 * previous society's page content (and its `document.title` effect) from
 * painting while the new lookup is in flight.
 */
export default function SocietyLoadingScreen() {
  useLayoutEffect(() => {
    document.title = 'Loading… | BreedLOGIC';
  }, []);

  return (
    <Box
      component="section"
      aria-busy="true"
      aria-live="polite"
      sx={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
